import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId } from '../../../utility/functions';
import Table from '../../../table/Table';

const WashClubReport = ({ ...props }) => {

    // const userConfig = {
    //     label: 'User Report',
    //     endpoint: QuestRoute.reports.mobile.WCReport,
    //     reportCallback: (data, setDate) => {
    //         setDate(data.washClubUsers);
    //     },
    //     isReport: true,
    //     headers: [
    //         {
    //             label: 'Name',
    //             propKey: 'name',
    //         }, {
    //             label: 'Email',
    //             propKey: 'email',
    //         }, {
    //             label: 'Club',
    //             propKey: 'club',
    //             options: true
    //         }, {
    //             label: 'Total Uses',
    //             propKey: 'totalUses',
    //         }, {
    //             label: 'Revenue Per Wash',
    //             propKey: 'revenuePerWash',
    //         },
    //     ],
    //     renderFormat: (e) => (
    //         <tr key={generateId()}>
    //             <td>
    //                 <LinkTo
    //                     target='_blank'
    //                     to={'/user/' + e.customerId}
    //                     label={e.name}
    //                 />
    //             </td>
    //             <td>{e.email}</td>
    //             <td>{e.club}</td>
    //             <td>{e.totalUses}</td>
    //             <td>{formatCurrency(e.revenuePerWash)}</td>
    //         </tr>
    //     )
    // }

    const clubConfig = {
        label: 'Wash Club Report',
        endpoint: QuestRoute.reports.mobile.WCReport,
        isReport: true,
        headers: [
            {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Uses',
                propKey: 'totalUses',
                type: 'number'
            }, {
                label: 'Total Users',
                propKey: 'totalUsers',
            }, {
                label: 'Price of Club',
                propKey: 'price',
                type: 'number'
            }, {
                label: 'Revenue Per Wash',
                propKey: 'avgRevenue',
                type: 'number'
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.name}</td>
                <td>{e.totalUses ?? 0}</td>
                <td>{e.totalUsers}</td>
                <td>{formatCurrency(e.price)}</td>
                <td>{formatCurrency(e.avgRevenue)}</td>
            </tr>
        )
    }



    return <Table config={clubConfig} />

    // return (
    //     <Col style={{ width: '100%' }}>
    //         <Table config={userConfig} />
    //         <Table config={clubConfig} />
    //     </Col>
    // );
}

export default WashClubReport;